import * as React from "react";
import { SVGAttributes } from "react";

export const DocsIcon = React.memo(
  ({
    size = 24,
    color = "#4E5361",
    ...props
  }: SVGAttributes<SVGElement> & {
    size?: number,
  }) => {
    return (
      <svg width={size} height={size} fill="none" {...props}>
        <path
          fill="#fff"
          d="M25.167.36a1.13 1.13 0 00-.812-.36H6.137C2.775 0 0 2.764 0 6.125v34.45c0 3.363 2.775 6.126 6.137 6.126h24.726c3.362 0 6.137-2.763 6.137-6.125V13.22c0-.294-.135-.575-.327-.79L25.167.361zm.327 3.622l7.705 8.088H28.19a2.686 2.686 0 01-2.696-2.685V3.982zm5.37 40.463H6.136c-2.11 0-3.88-1.748-3.88-3.87V6.126c0-2.11 1.759-3.869 3.88-3.869h17.1v7.13a4.935 4.935 0 004.953 4.94h6.554v26.25c0 2.12-1.76 3.87-3.88 3.87z"
        />
        <path
          fill="#fff"
          d="M27.784 36.662H9.216c-.62 0-1.128.508-1.128 1.128 0 .62.508 1.128 1.128 1.128h18.58c.62 0 1.128-.507 1.128-1.128 0-.62-.508-1.128-1.14-1.128zm-10.108-4.05c.215.226.508.361.824.361.316 0 .609-.135.823-.36l6.61-7.096a1.124 1.124 0 00-.056-1.59 1.124 1.124 0 00-1.59.056l-4.66 4.997V16.662c0-.62-.507-1.128-1.127-1.128s-1.128.507-1.128 1.128V28.98l-4.648-4.997a1.124 1.124 0 00-1.59-.056 1.124 1.124 0 00-.057 1.59l6.6 7.095z"
        />
      </svg>
    );
  }
);
